import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Preserves old Care Portal URLs by redirecting them under /care-portal/*.
 * Ensures existing bookmarks, admin flows, and API callbacks keep working.
 */
export default function LegacyRedirect({ to }) {
  const location = useLocation();
  const params = useParams();
  let dest = to;
  Object.entries(params).forEach(([k, v]) => {
    dest = dest.replace(`:${k}`, v);
  });
  return <Navigate to={`${dest}${location.search || ""}${location.hash || ""}`} replace />;
}
